import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';

const SvgTw48Rounded = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  "aria-label": "Taiwan",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#e7e7e7",
  d: "M12 21.41A9.41 9.41 0 1 0 2.59 12 9.41 9.41 0 0 0 12 21.41z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#d43630",
  d: "M21.4 11.59a1.3 1.3 0 0 0 0-.2 9.41 9.41 0 1 0 0 1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000095",
  d: "M15.51 3.26a9.3 9.3 0 0 0-4.12-.65A9.4 9.4 0 0 0 2.59 12h12.92z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M9.41 9A1.81 1.81 0 1 0 7.6 7.19 1.81 1.81 0 0 0 9.41 9m1.35-3.32L11.24 4 10 5.26a2 2 0 0 1 .76.42m-1.97-.42L7.58 4l.48 1.66a2 2 0 0 1 .73-.4"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M9.41 5.16a2 2 0 0 1 .42 0l-.42-1.64L9 5.21a2 2 0 0 1 .41-.05m-1.51.67-1.67-.48 1.25 1.21a2 2 0 0 1 .42-.73m5.17 1.36-1.68-.42a2 2 0 0 1 0 .84zm-1.74-.63 1.25-1.21-1.67.48a1.9 1.9 0 0 1 .42.73M9.41 9.21a2 2 0 0 1-.42 0l.42 1.68.42-1.68a2 2 0 0 1-.42 0m1.5-.67 1.67.46-1.24-1.19a2.1 2.1 0 0 1-.43.73M7.38 7.19a2 2 0 0 1 0-.42l-1.69.42 1.69.42a2 2 0 0 1 0-.42M10 9.12l1.21 1.24-.48-1.67a2.1 2.1 0 0 1-.73.43m-1.95-.43-.47 1.67 1.21-1.24a2 2 0 0 1-.74-.43m-.57-.88L6.24 9l1.66-.46a2 2 0 0 1-.42-.73"
}));

export { SvgTw48Rounded as default };
//# sourceMappingURL=Tw48Rounded.js.map
